import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
import { NeutralIncidentTypeEnum } from "@/modules/match/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'NeutralIncident',
  props: {
    rightSide: {
      type: Boolean
    },
    incident: null
  },
  setup(__props) {
    const props = __props;
    const iconMap = {
      [NeutralIncidentTypeEnum.START]: IconEnum.ClockRegular,
      [NeutralIncidentTypeEnum.END]: IconEnum.ClockRegular,
      [NeutralIncidentTypeEnum.START_EXTRA_TIME]: IconEnum.ClockRegular,
      [NeutralIncidentTypeEnum.END_EXTRA_TIME]: IconEnum.ClockRegular,
      [NeutralIncidentTypeEnum.NOT_ENOUGH_PlAYERS]: IconEnum.ClockRegular,
      [NeutralIncidentTypeEnum.START_PENALTY]: IconEnum.ClockRegular,
      [NeutralIncidentTypeEnum.END_PENALTY]: IconEnum.ClockRegular
    };
    const labelMap = {
      [NeutralIncidentTypeEnum.START]: 'start_regular_time',
      [NeutralIncidentTypeEnum.END]: 'end_regular_time',
      [NeutralIncidentTypeEnum.START_EXTRA_TIME]: 'start_extra_time',
      [NeutralIncidentTypeEnum.END_EXTRA_TIME]: 'end_extra_time',
      [NeutralIncidentTypeEnum.NOT_ENOUGH_PlAYERS]: 'not_enough_players',
      [NeutralIncidentTypeEnum.START_PENALTY]: 'start_penalty',
      [NeutralIncidentTypeEnum.END_PENALTY]: 'end_penalty'
    };
    const icon = ref(iconMap[props.incident.neutralType]);
    const label = ref(labelMap[props.incident.neutralType]);
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex items-center", {
          'text-right': !__props.rightSide,
          'justify-center flex-col': __props.incident.fullWidth
        }])
      }, [!__props.incident.fullWidth ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.rightSide ? (_openBlock(), _createBlock(_component_Icon, {
        key: 0,
        icon: icon.value,
        size: "1rem",
        class: "mr-1"
      }, null, 8, ["icon"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.$t(label.value)) + " ", 1), !__props.rightSide ? (_openBlock(), _createBlock(_component_Icon, {
        key: 1,
        icon: icon.value,
        size: "1rem",
        class: "ml-1"
      }, null, 8, ["icon"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_Icon, {
        icon: icon.value,
        size: "1rem",
        class: "mb-2"
      }, null, 8, ["icon"]), _createElementVNode("div", null, _toDisplayString(_ctx.$t(label.value)), 1)], 64))], 2);
    };
  }
});